export default "__VITE_ASSET__aSd33jdY__"